import { render } from "./RegisterProdDesktop.vue?vue&type=template&id=49462abe&scoped=true"
import script from "./RegisterProdDesktop.vue?vue&type=script&lang=js"
export * from "./RegisterProdDesktop.vue?vue&type=script&lang=js"

import "./RegisterProdDesktop.vue?vue&type=style&index=0&id=49462abe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49462abe"]])

export default __exports__